import React from 'react';
import Banner from "../base/Banner";
import {getStyle} from "../../services/Style";
import ProfileButtons from "../base/ProfileButtons";
import getCustomerData from "../../services/DataGetter";
import {setLanguage} from "../../enums/Languages";

export default class ProfileLandingPage extends React.PureComponent
{
    constructor(props){
        super(props);

        this.state = {
            language: setLanguage(this.props.match.params['lang']),
            customerData: getCustomerData(this.props.match.params['customerName']),
        };
    }

    render(){
        const {language} = this.state;
        return (
            <>
                <Banner
                    customerName={this.props.match.params['customerName']}
                    language={language}
                    customerData={this.state['customerData']}
                />
                <div className="alice-bg padding-top-30 section-padding-bottom flexHeight" style={getStyle( this.props.match.params['positionId'], 'backgroundColor', this.props.match.params['customerName'])}>
                    <div className="container">
                        <div className="row">
                            <div className="col">
                                <div className="job-listing-details job-detail-position">
                                    <div className=" section-padding-30">
                                        <div className={'col-12 padding-left-30'}>
                                            <h4>{sessionStorage.getItem('userName-' + this.props.match.params['customerName'])}</h4>
                                            <div className={'margin-bottom-30'}>
                                                <i className={'fa fa-at'} /> {sessionStorage.getItem('email-' + this.props.match.params['customerName'])} <br/>
                                                <i className={'fa fa-phone-square'} /> { sessionStorage.getItem('phone-'+ this.props.match.params['customerName'])} <br/>
                                            </div>
                                        </div>
                                        <ProfileButtons
                                            positionId={ this.props.match.params['positionId']}
                                            language = {language}
                                            customerName = {this.props.match.params['customerName']}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }

}
